module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAUCAYAAAC58NwRAAAAAXNSR0IArs4c6QAAALJJREFUOE+V070KwjAYheE34mDB1cRLcFDQO9BB8K51d1DQwUuw7Vpw6yepEFrb/DTzeUI44ShGHmXzpeGKMM3gNC/IQ3c0oDA8FKyBVybsQ+gHFizVhDOwiqEGjEEOpKIOSEE9EEODIIS84B8JPHXOJggqjfkoLrZuEe66YOcF7bD9G6k56JL3IPCF7TN7IBTugVi4A1LCDqSGHSg1NxTbdhu+TbgBCcyoOdrqogMas9IvfRJ4FbELrkAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cartojourney/img23.png
// module id = fxp2
// module chunks = 1